module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DYPhJo/tc-custom/9781637968253.jpg?1693338706552",
      "alt": "This image is the cover for the book Something is Killing the Children Pen & Ink #1, Something is Killing the Children Pen & Ink"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Something is Killing the Children Pen & Ink #1, Something is Killing the Children Pen & Ink\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("BOOM! Studios is proud to present PEN & INK, a deluxe art-focused format featuring stunning black and white interior inks with artist commentary. Begin your collection with this premium reformat of Something is Killing the Children #1, celebrating the start of Erica Slaughter’s epic journey with exclusive notes and annotations from artist and co-creator Werther Dell'Edera. This issue will be available with a premium cardstock cover, alongside a gorgeous Spot UV variant cover and a blank sketch cover.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Tynion IV, Werther Dell’Edera\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0